import React from 'react';
import { FeedbackListItem } from './feedback-list-item';
import { ListContainer } from './styled-components';
type Props = {
  list: {
    label: string;
    description: string;
  }[];
  onEditFeedback: (index: number) => void;
  isDeleteMode?: boolean;
  selectedItems?: Set<number>;
  onItemSelect?: (index: number) => void;
};
export const FeedbackList = ({
  list,
  onEditFeedback,
  isDeleteMode = false,
  selectedItems = new Set(),
  onItemSelect
}: Props) => {
  return <ListContainer>
      {list.map((item, index) => <FeedbackListItem key={`${item.label}-${index}`} label={item.label} description={item.description} isLast={index === list.length - 1} onEditFeedback={() => onEditFeedback(index)} isSelectMode={isDeleteMode} isSelected={selectedItems.has(index)} onSelect={() => onItemSelect?.(index)} />)}
    </ListContainer>;
};